import { ReactNode } from 'react';
import classNames from 'classnames';
import { AlgoliaHit, AlgoliaResultType } from 'types/Search/Algolia';
import { COLOR_BRAND_PRIMARY, COLOR_TEXT_PLACEHOLDER } from '@alltrails/shared/denali/tokens';
import Filter from '@alltrails/shared/icons/Filter';
import Hiking from '@alltrails/shared/icons/Hiking';
import TrailDog from '@alltrails/shared/icons/TrailDog';
import List from '@alltrails/shared/icons/List';
import Map from '@alltrails/shared/icons/Map';
import Park from '@alltrails/shared/icons/PlacePark';
import Place from '@alltrails/shared/icons/Place';
import Record from '@alltrails/shared/icons/Record';
import Trail from '@alltrails/shared/icons/PlaceTrail';
import Waterfall from '@alltrails/shared/icons/PlaceWaterfall';
import Mountain from '@alltrails/shared/icons/PlaceMountain';
import Photo from '@alltrails/shared/icons/Photo';
import * as styles from './styles/styles.module.scss';

export type Props = {
  isActive?: boolean;
  isSmallVariant?: boolean;
  result: AlgoliaHit;
};

const IconWithBackground = (Icon: ReactNode, isSmallVariant?: boolean): JSX.Element => (
  <div className={classNames({ [styles.iconContainer]: true, [styles.smallVariant]: isSmallVariant })}>{Icon}</div>
);

function SearchResultIcon({ isActive, isSmallVariant = false, result }: Props) {
  const color = isActive ? COLOR_BRAND_PRIMARY : COLOR_TEXT_PLACEHOLDER;
  const size = isSmallVariant ? 'sm' : 'md';

  switch (result.type) {
    case AlgoliaResultType.Trail:
      return IconWithBackground(<Trail color={color} size={size} />, isSmallVariant);
    case AlgoliaResultType.Track:
      return IconWithBackground(<Record color={color} size={size} />, isSmallVariant);
    case AlgoliaResultType.Place:
      return IconWithBackground(<Place color={color} size={size} />, isSmallVariant);
    case AlgoliaResultType.List:
      return IconWithBackground(<List color={color} size={size} />, isSmallVariant);
    case AlgoliaResultType.Area:
      return IconWithBackground(<Park color={color} size={size} />, isSmallVariant);
    case AlgoliaResultType.Map:
      return IconWithBackground(<Map color={color} size={size} />, isSmallVariant);
    case AlgoliaResultType.Filter:
      if (result?.filters?.activities?.includes('hiking')) {
        return IconWithBackground(<Hiking color={color} size={size} />, isSmallVariant);
      }

      if (result?.filters?.access?.includes('dogs')) {
        return IconWithBackground(<TrailDog color={color} size={size} />, isSmallVariant);
      }

      if (result?.filters?.features?.includes('waterfall')) {
        return IconWithBackground(<Waterfall color={color} size={size} />, isSmallVariant);
      }

      return IconWithBackground(<Filter color={color} size={size} />, isSmallVariant);
    case AlgoliaResultType.POI:
      if (result?.subtype === 'peak') {
        return IconWithBackground(<Mountain color={color} size={size} />, isSmallVariant);
      }

      if (result?.subtype === 'waterfall') {
        return IconWithBackground(<Waterfall color={color} size={size} />, isSmallVariant);
      }

      return IconWithBackground(<Photo color={color} size={size} />, isSmallVariant);
    default:
      return null;
  }
}

export default SearchResultIcon;
